import { useEffect, useRef, useState } from "react";
import { getCase } from "../../content/lookups.js";
import type { NodeDefinition, NodeId } from "../../domain/types/index.js";
import { useGame } from "../../app/GameProvider.js";
import { TopBar } from "../shared/TopBar.js";
import { MapGraph, nodeById } from "./MapGraph.js";
import { canProceedOnMap, mapNodeVisual } from "./mapPeek.js";
import { NodeDetailSheet } from "./NodeDetailSheet.js";

export function MapScreen() {
  const { state, dispatch } = useGame();
  const [selectedId, setSelectedId] = useState<NodeId | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const run = state.run;

  useEffect(() => {
    const current = scrollRef.current?.querySelector(".map-node.is-current");
    if (current && typeof current.scrollIntoView === "function") {
      current.scrollIntoView({ block: "center" });
    }
  }, [run?.currentNodeId]);

  if (!run) return null;

  const selected = selectedId ? nodeById(selectedId, run.stageId) ?? null : null;
  const selectedVisual = selected ? mapNodeVisual(selected.id, run, state.screen) : null;
  const handleSelect = (node: NodeDefinition) =>
    setSelectedId((prev) => (prev === node.id ? null : node.id));

  return (
    <section className="screen screen-map">
      <TopBar />
      <section className="map-guide" aria-label="次にすること">
        <img className="map-guide-portrait" src="/secretary.png" alt="秘書" />
        <div className="map-guide-message">
          <span>秘書</span>
          <p>プロジェクトを開くとハプニングの特徴を確認できます。</p>
        </div>
      </section>
      <div className="map-scroll" ref={scrollRef}>
        <MapGraph run={run} screen={state.screen} selectedId={selectedId} onSelect={handleSelect} />
      </div>
      {selected && selectedVisual && (
        <NodeDetailSheet
          node={selected}
          spec={(selected.caseId ? getCase(selected.caseId) : null) ?? null}
          visual={selectedVisual}
          stageId={run.stageId}
          canProceed={canProceedOnMap(state.screen, selectedVisual)}
          onClose={() => setSelectedId(null)}
          onProceed={() => {
            dispatch({ type: "SELECT_NODE", nodeId: selected.id });
            setSelectedId(null);
          }}
        />
      )}
    </section>
  );
}
